module.exports = __webpack_public_path__ + "img/mobile-menu.d1381bf.svg";